<!--================================
=            ECHARTSPIE            =
=================================-->


<template>
  <div id="echart2" style="height:250px">

  </div>

</template>

<script>
  export default {

    mounted() {

      var chartDom = document.getElementById('echart2');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        legend: {
          show: false
        },
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        series: [{
          name: 'Nightingale Chart',
          type: 'pie',
          radius: [50, 100],
          center: ['50%', '50%'],
          color: [
            '#009999',
            '#007a7a',
            '#006b6b',
            '#005b5b',
            '#004c4c',
            '#003d3d',
            '#66c1c1',
            '#bbeeff'
          ],
          roseType: 'area',
          symbolSize: 10,
          symbol: 'circle',
          smooth: true,

          itemStyle: {
            borderRadius: 8,
            width: 3,
            shadowColor: 'rgba(0,0,0,0.3)',
            shadowBlur: 10,
            shadowOffsetY: 8
          },
          data: [{
              value: 40,
              name: 'Pessoal'
            },
            {
              value: 38,
              name: 'Finances'
            },
            {
              value: 32,
              name: 'Profit'
            },
            {
              value: 30,
              name: 'Loss'
            },
            {
              value: 28,
              name: 'Body'
            },
            {
              value: 26,
              name: 'School'
            },
            {
              value: 22,
              name: 'Hobbie'
            },
            {
              value: 18,
              name: 'Job'
            }
          ]
        }]
      };

      option && myChart.setOption(option);

    },
  }
</script>

<!--====  End of ECHARTSPIE  ====-->